import actions from './actions';

const initState = {
    settings   : {
        data: []
    },
    loading : false,
    message: null,
    type: null,
    status: null,
};

export default function fetchSettingsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_SETTINGS_REQUESTED:
            return {
                ...state,
                settings   : {
                    data: []
                },
                loading : true,
                message: null,
                type: null
            };
        case actions.FETCH_SETTINGS_SUCCEEDED:
            return {
                ...state,
                settings    : action.settings,
                loading     : false,
                message: null,
                type: null
            };
        case actions.FETCH_SETTINGS_FAILED:
            return {
                ...state,
                loading : false,
                message: null,
                type: null
            };
        case actions.UPDATE_SETTINGS_REQUESTED:
            return {
                ...state,
                settings   : {
                    data: []
                },
                loading : true,
                message: null,
                type: null
            };
        case actions.UPDATE_SETTINGS_SUCCEEDED:
            return {
                ...state,
                settings    : action.settings,
                loading     : false,
                message     : "Settings Updated Successfully!",
                type     : "success",
                status  : 200
            };
        case actions.UPDATE_SETTINGS_FAILED:
            return {
                ...state,
                loading : false,
                message: action.error?.message,
                type: "danger",
                status: action.error?.status
            };
        case actions.CLEAR_ALERT_MESSAGE:
            return {
                ...state,
                message: null,
                type: null
            };
        default:
            return state;
    }
}
